import Grid from "../grid/Grid";

/**
 * @abstract
 */
export class TerrainGenerator {
    constructor() {        
    }

    /**
     * @abstract
     * @param {Grid} grid 
     */
    generateTerrain(grid) {}

    /**
     * When we load a grid from the save file, we need to generate the background,
     * because that isn't in the save file but can be derived form the tile types.
     * @param {Grid} grid 
     */
    generateTileBackgrounds(grid) {}
}